export default "__VITE_ASSET__5bfe83ae__"